import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../components/layout";
import Button from "../components/button";
import Modal from "../components/modal";
import projects, { getProjectById } from "../data/projects";

export default function WorkPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedId, setSelectedId] = useState(null);
  const selectedProject = getProjectById(selectedId);

  useEffect(() => {
    const projectFromUrl = searchParams.get("project");
    if (!projectFromUrl) return;
    if (!getProjectById(projectFromUrl)) return;
    setSelectedId(projectFromUrl);
  }, [searchParams]);

  const openProject = (projectId) => {
    setSelectedId(projectId);
    setSearchParams({ project: projectId });
  };

  const closeProject = () => {
    setSelectedId(null);
    if (!searchParams.get("project")) return;
    const next = new URLSearchParams(searchParams);
    next.delete("project");
    setSearchParams(next, { replace: true });
  };

  return (
    <Layout>
      <div className="container py-5">
        <div className="work-header">
          <h1 className="mb-3">Our Work</h1>
          <p className="text-muted mb-4">
            A selection of projects across branding, web, and design. Click any
            project to see a deeper breakdown.
          </p>
          <Button to="/contact" type="cta">
            Start a project
          </Button>
        </div>

        <div className="work-grid">
          {projects.map((project) => (
            <div
              key={project.id}
              className={`work-card-wrap work-card-wrap--${project.outlineStyle || "black"}`}
            >
              <button
                type="button"
                className="work-card"
                onClick={() => openProject(project.id)}
                style={{ backgroundImage: `url(${project.heroImage})` }}
              >
                <div className="work-card__overlay" />
                <div className="work-card__content">
                  <div className="work-card__category">{project.category}</div>
                  <div className="work-card__title">{project.title}</div>
                  <div className="work-card__cta">View project</div>
                </div>
              </button>
            </div>
          ))}
        </div>
      </div>

      <Modal show={Boolean(selectedProject)} handleClose={closeProject}>
        {selectedProject ? (
          <div className="work-modal">
            <div
              className="work-modal__hero"
              style={{ backgroundImage: `url(${selectedProject.heroImage})` }}
            >
              <div className="work-modal__heroOverlay" />
              <div className="work-modal__heroInner">
                <div className="work-modal__category">{selectedProject.category}</div>
                <h2 className="work-modal__title">{selectedProject.title}</h2>
                <p className="work-modal__summary">{selectedProject.summary}</p>
              </div>
            </div>

            <div className="work-modal__body">
              <div className="work-modal__section">
                <h3>Services</h3>
                <ul>
                  {selectedProject.services.map((s) => (
                    <li key={s}>{s}</li>
                  ))}
                </ul>
              </div>

              <div className="work-modal__section">
                <h3>Outcomes</h3>
                <ul>
                  {selectedProject.outcomes.map((o) => (
                    <li key={o}>{o}</li>
                  ))}
                </ul>
              </div>

              <div className="work-modal__footer">
                <Button to="/contact">Work with us</Button>
              </div>
            </div>
          </div>
        ) : null}
      </Modal>
    </Layout>
  );
}
